export const environment = {
  name: 'dev',
  apiUrl: 'https://admin.stockoutmonitor.dev.my-sandoz.com/api/v1',
  production: false,
  serviceWorker: false,
  googleAnalyticsId: '',
  clarityId: '',
};
